import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseMutationClearOptions } from 'shared/types/tanstack-utility-types'

interface UseDeleteCommentOptions extends UseMutationClearOptions<void, Error, void> {
  commentId: number
}

export const useDeleteComment = ({
  commentId,
  ...options
}: UseDeleteCommentOptions): UseMutationResult<void, Error, void> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.delete, void, void>({
    method: RequestMethodsEnum.delete,
  })

  return useMutation({
    mutationFn: () => fetcher(`${COMMENT_API_PREFIX}/${commentId}`),
    ...options,
  })
}
